import jwtDefaultConfig from './jwtDefaultConfig'
import { BToast } from 'bootstrap-vue'

const resolveVariant = (type) =>{
  if(type == 'error') return 'danger'
  if(type == 'warning') return 'warning'
  if(type == 'success') return 'success'
  if(type == 'information') return 'info'
}

export default class JwtService {

  // Will be used by this service for making API calls
  axiosIns = null

  // jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig }

  // For Refreshing Token
  isAlreadyFetchingAccessToken = false

  // For Refreshing Token
  subscribers = []

  constructor(axiosIns, jwtOverrideConfig) {
    this.axiosIns = axiosIns
    this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }

    // Request Interceptor
    this.axiosIns.interceptors.request.use(
        config => {
          // Get token from localStorage
          const accessToken = this.getToken()

          // If token is present add it to request's Authorization Header
          if (accessToken) {
            // eslint-disable-next-line no-param-reassign
            config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
          }
          return config
        },
        error => Promise.reject(error),
    )

    // Add request/response interceptor
    this.axiosIns.interceptors.response.use(
        response => {

          // Processa notificações se existirem
          if (response.headers && response.headers.notifications && response.headers.notifications.length > 0) {
            this.processNotifications(response.headers.notifications);
          }

          return response
        },
        async error => {
          const { config, response } = error
          const originalRequest = config

          // Processa notificações de erro se existirem
          if (response && response.headers && response.headers.notifications) {
            this.processNotifications(response.headers.notifications);
          }

          // Tratamento de erro 401 (Unauthorized)
          if (response && response.status === 401) {

            if (!this.isAlreadyFetchingAccessToken) {
              this.isAlreadyFetchingAccessToken = true

              try {
                const refreshResponse = await this.refreshToken();
                this.isAlreadyFetchingAccessToken = false

                // Update accessToken in localStorage
                this.setToken(refreshResponse.data.accessToken)
                this.setRefreshToken(refreshResponse.data.refreshToken)

                this.onAccessTokenFetched(refreshResponse.data.accessToken)

                // Retry da requisição original com novo token
                const retryOriginalRequest = new Promise(resolve => {
                  this.addSubscriber(accessToken => {
                    originalRequest.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
                    resolve(this.axiosIns(originalRequest))
                  })
                })

                return retryOriginalRequest

              } catch (refreshError) {
                this.isAlreadyFetchingAccessToken = false
                // Se o refresh falhar, rejeita o erro original
                return Promise.reject(error)
              }
            } else {
              // Se já está fazendo refresh, aguarda e tenta novamente
              const retryOriginalRequest = new Promise(resolve => {
                this.addSubscriber(accessToken => {
                  originalRequest.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
                  resolve(this.axiosIns(originalRequest))
                })
              })

              return retryOriginalRequest
            }
          }

          // Para outros erros, simplesmente rejeita
          return Promise.reject(error)
        },
    )
  }

  // Método auxiliar para processar notificações
  processNotifications(notifications) {
    try {
      let bootStrapToaster = new BToast();
      var notificationList = JSON.parse(notifications);

      notificationList.forEach(node => {
        bootStrapToaster.$bvToast.toast(node.text, {
          title: `✉️ ${node.type.toUpperCase()}`,
          toaster: "b-toaster-bottom-right",
          solid: true,
          variant: resolveVariant(node.type),
          appendToast: false
        })
      });
    } catch (_) {}
  }

  onAccessTokenFetched(accessToken) {
    this.subscribers = this.subscribers.filter(callback => callback(accessToken))
  }

  addSubscriber(callback) {
    this.subscribers.push(callback)
  }

  getToken() {
    return localStorage.getItem(this.jwtConfig.storageTokenKeyName)
  }

  getRefreshToken() {
    return localStorage.getItem(this.jwtConfig.storageRefreshTokenKeyName)
  }

  setToken(value) {
    localStorage.setItem(this.jwtConfig.storageTokenKeyName, value)
  }

  setRefreshToken(value) {
    localStorage.setItem(this.jwtConfig.storageRefreshTokenKeyName, value)
  }

  login(...args) {
    return this.axiosIns.post(this.jwtConfig.loginEndpoint, ...args)
  }

  register(...args) {
    return this.axiosIns.post(this.jwtConfig.registerEndpoint, ...args)
  }

  refreshToken() {
    return this.axiosIns.post(this.jwtConfig.refreshEndpoint, {
      refreshToken: this.getRefreshToken(),
    })
  }
}